import { PlusOutlined } from '@ant-design/icons';
import { DatePicker, Input, TimePicker, Upload } from "antd";
import moment from "moment";

const {TextArea} = Input;
const {Dragger} = Upload;


const baseClasses =
    "bg-[#48474E] text-white placeholder-gray-400 focus:bg-[#48474E] hover:bg-[#48474E] focus:!shadow-none";

const getBorderClass = (status) =>
    status === "error" ? "border-red-500" : "border-gray-500";

const ModalInput = ({className = "", status, ...rest}) => {
    return (
        <Input
            {...rest}
            status={status}
            className={`${baseClasses} ${getBorderClass(status)} ${className}`}
            style={{
                backgroundColor: "#48474E",
            }}
        />
    );
};

const ModalTextArea = ({className = "", status, rows = 4, ...rest}) => {
    return (
        <TextArea
            {...rest}
            status={status}
            rows={rows}
            className={`${baseClasses} ${getBorderClass(status)} ${className}`}
            style={{
                backgroundColor: "#48474E",
            }}
        />
    );
};

const ModalDatePicker = ({className = "", status, disabledDate, ...rest}) => {
    return (
        <DatePicker
            {...rest}
            status={status}
            disabledDate={disabledDate || ((current) => current && current > moment())}
            className={`${baseClasses} ${getBorderClass(status)} ${className}`}
            style={{width: "100%", backgroundColor: "#48474E"}}
        />
    );
}

const ModalTimePicker = ({className = "", status, ...rest}) => {
    return (
        <TimePicker
            {...rest}
            status={status}
            format="HH:mm"
            minuteStep={5}
            showNow={true}
            className={`${baseClasses} ${getBorderClass(status)} ${className}`}
            style={{width: "100%", backgroundColor: "#48474E"}}
        />
    );
}

const ModalUpload = ({className = "", status,uploadHint,supportTypeHint, ...rest}) => {
    return (
        <Dragger
  {...rest}
  beforeUpload={() => false}
  className={`${baseClasses} ${getBorderClass(status)} ${className}`}
  listType="picture"
>
  <div /*</Dragger>className="flex items-center justify-center p-4 border-2 border-dashed border-gray-500 rounded cursor-pointer hover:border-purple-500 transition-colors"*/>
    <div className="text-center">
      <PlusOutlined className="text-2xl mb-2" />
      <div className="text-sm font-medium">{uploadHint}</div>
      <div className="text-xs text-gray-400 mt-1">
        {supportTypeHint}
      </div>
    </div>
  </div>
</Dragger>
    );
};

export { ModalDatePicker, ModalInput, ModalTextArea, ModalTimePicker, ModalUpload };

